<template>
  <div
    v-if="blok.image && blok.image.filename"
    v-editable="blok"
    class="image-container"
    :style="imageWidth"
    :class="[topSpacing]"
  >
    <img
      :src="blok.image && blok.image.filename"
      :alt="blok.image && blok.image.alt"
      :class="['image', { 'rounded-image': blok.rounded }]"
      loading="lazy"
    />
  </div>
</template>

<script lang="ts" setup>
import type { SbPictureGridImageStoryblok } from '@/types'
interface Props {
  blok: SbPictureGridImageStoryblok
}
const props = defineProps<Props>()

const topSpacing = computed(() => {
  return `space-top-${props.blok.top_spacing}` ?? ''
})

const imageWidth = computed(() => {
  if (props.blok.image_width === '0' || props.blok.image_width === '') {
    return 'width: 100%;'
  }
  return `width: ${props.blok.image_width}px`
})
</script>

<style lang="scss" scoped>
.image-container {
  margin: 0 auto;

  @media (min-width: $breakpoint-lg) {
    margin: 0;
  }
}

.image {
  width: 100%;
  height: auto;
  display: block;
}

.rounded-image {
  border-radius: 14px;
}

@each $name, $space in $spacing {
  .space-top-#{$name} {
    padding-top: 0;

    @media (min-width: $breakpoint-lg) {
      padding-top: $space;
    }
  }
}

@each $name, $space in $spacing-small {
  .space-top-#{$name} {
    padding-top: 0;

    @media (min-width: $breakpoint-lg) {
      padding-top: $space;
    }
  }
}
</style>
